import React, { useContext, useRef, useState } from 'react';
import { Container, Stack } from '@mui/material';

import Departments from './Components/Departments/Departments';
import useFetchDepartments from './Hooks/useFetchDepartments';
import useLockForward from './Hooks/useLockForward';
import TurnBase from './Components/TurnBase/TurnBase';
import TurnItems from './Components/TurnItems/TurnItems';
import useFetchServiceOrSpeciality from './Hooks/useFetchServiceOrSpeciality';
import useFetchDoctors from './Hooks/useFetchDoctors';
import Doctors from './Components/Doctors/Doctors';
import NearestTurn from './Components/NearestTurn/NearestTurn';
import { selectedDepartmentAtom } from './shared/selected.department';
import { useAtom } from 'jotai';
import CenterUnit from './Components/CenterUnit/CenterUnit';
import OtherTurns from './Components/OtherTurns/OtherTurns';
import Terms from './Components/Terms/Terms';
import useFetchPageConfig from './Hooks/useFetchPageConfig';
import StepButtons from './Components/Stepper/Stepper';
import ServiceSpeciality from './Components/ServiceSpeciality/ServiceSpeciality';
import useFetchSpecialityServices from './Hooks/useFetchSpecialityServices';
import useFetchDepartmentIdList from './Hooks/useFetchDepartmentIdList';
import { CheckPardakhtBeforSave } from './adapaters/CheckPardakhtBeforSave';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';

const GetNewTurn = () => {
  const markazSettings =
    useContext(GlobalContext)?.appConfig;

  const controlBtn_ref = useRef(null);

  // useEffect(() => {
  //   const isPayRedirected =
  //     localStorage.getItem('pay_redirect');

  //   console.log('isPayRedirected=>', isPayRedirected);

  //   if (!!isPayRedirected) {
  //     CheckPardakhtBeforSave(JSON.parse(isPayRedirected));
  //   }
  // }, []);

  const [steps, setSteps] = useState(0);
  const [acceptTerms, setAcceptTerms] = useState(false);

  const [selected] = useAtom(selectedDepartmentAtom);

  const pageConfig = useFetchPageConfig();

  const termConfigs = {
    config: pageConfig,
    setAcceptTerms,
    acceptTerms,
  };

  const departments = useFetchDepartments();

  const turnBaseData = useFetchServiceOrSpeciality();

  const doctors = useFetchDoctors(turnBaseData, steps);

  const specialityService = useFetchSpecialityServices(
    doctors,
    steps
  );

  useFetchDepartmentIdList();

  const isForwardLocked = useLockForward(
    termConfigs,
    steps,
    doctors,
    turnBaseData,
    specialityService,
    departments
  );

  return (
    <React.Fragment>
      <Container>
        <Stack sx={{ mt: '1em' }}>
          {steps === 0 ? (
            <Terms
              {...termConfigs}
              data={{ departments, turnBaseData }}
            />
          ) : (
            <></>
          )}
          {/* {steps !== 0 ? <StepIndicator /> : <></>} */}
          {steps === 1 ? (
            <Departments
              departments={departments}
              turnBaseData={turnBaseData}
            />
          ) : (
            <></>
          )}
          {steps === 2 ? (
            selected.NobatBaPezeshKYaVahed === 2 ? (
              <CenterUnit turnBaseData={turnBaseData} />
            ) : (
              <TurnBase turnBaseData={turnBaseData} />
            )
          ) : (
            <></>
          )}
          {steps === 3 ? (
            <TurnItems
              turnBaseData={turnBaseData}
              doctors={doctors}
              controlBtn_ref={controlBtn_ref}
              setSteps={setSteps}
            />
          ) : (
            <></>
          )}
          {steps === 4 ? (
            <NearestTurn doctors={doctors} />
          ) : (
            <></>
          )}
          {steps === 5 ? (
            <Doctors
              doctors={doctors}
              controlBtn_ref={controlBtn_ref}
              setSteps={setSteps}
            />
          ) : (
            <></>
          )}
          {steps === 6 ? (
            <ServiceSpeciality
              specialityService={specialityService}
              setSteps={setSteps}

            />
          ) : (
            <></>
          )}
          {steps === 7 ? (
            <OtherTurns turnBaseData={turnBaseData} />
          ) : (
            <></>
          )}
          <StepButtons
            steps={steps}
            setSteps={setSteps}
            isForwardLocked={isForwardLocked}
            acceptTerms={acceptTerms}
            pageConfig={pageConfig}
            turnBaseData={turnBaseData}
            doctors={doctors}
            specialityService={specialityService}
            controlBtn_ref={controlBtn_ref}
            departments={departments}
          />
          <br />
        </Stack>
      </Container>
    </React.Fragment>
  );
};

export default GetNewTurn;
